import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Segment, Container } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const CountAllSuccess = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    loadCountAllSuccess,
    countAllSuccess,
  } = rootStore.dashboardStore;

  return (
    <Segment className="totalDocumentos" clearing>
      <div>
        <div className="graphictitle">
        <p>Total documentos electrónicos</p> 
        </div>
        <div className="graphicontwithoutpadd">      
      {!loadCountAllSuccess ? (
        <LoadingComponent content="Cargando" />
      ) : (
        <Container textAlign="center">
          <p className="greenlabelstyle size250">{countAllSuccess}</p>
        </Container>
      )}</div>
      </div>
    </Segment>
  );
};

export default observer(CountAllSuccess);
